import React from "react";
import { message } from "antd";
import { useMount } from "react-use";
import { errorMessage, isTrue } from "service/service";
import { dynamicLogin } from "service/auth";
import { useAtomValue } from "jotai";
import { loginModeAtom } from "service/stores/SettingsStore";
import Storage from "utils/Storage";
import LoginComponent from "../components/LoginComponent";
import useRequestFn from "utils/useRequestFn";
import { FormFields } from "../components/LoginComponent/components/AccountMode";

export default function LoginConsole() {
    const loginMode = useAtomValue(loginModeAtom);

    useMount(() => {
        Storage.clear();
    });

    const [onFinish, { loading }] = useRequestFn(async (data: FormFields) => {
        try {
            await dynamicLogin(data.loginName, data.pwd);
            window.location.href = "/";
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    if (!isTrue(loginMode.dynamicCertLogin))
        return <div>后台禁止了动态码登录</div>;

    return <LoginComponent onSubmit={onFinish} loading={loading} />;
}
